export const validateRangeFilter = (filterArr: string[]): boolean => {
  if (filterArr.length < 3) return false;
  if (!validateStringArray(filterArr)) return false;
  const conditions = [];
  for (let i = 1; i < filterArr.length; i += 2) {
    const op = filterArr[i];
    const num = parseFloat(filterArr[i + 1]);
    if (isNaN(num)) return false;
    conditions.push({ op, value: num });
  }

  const eqConditions = conditions.filter((c) => c.op === '=');
  if (eqConditions.length > 0) {
    const eqValue = eqConditions[0].value;
    for (const cond of conditions) {
      const condition = mapTextToRelationaOperator(cond.op);
      switch (condition) {
        case '=':
          if (cond.value !== eqValue) return false;
          break;
        case '>=':
          if (!(eqValue >= cond.value)) return false;
          break;
        case '<=':
          if (!(eqValue <= cond.value)) return false;
          break;
      }
    }
    return true;
  }

  let lowerBound = { value: -Infinity, inclusive: false };
  let upperBound = { value: Infinity, inclusive: false };

  for (const cond of conditions) {
    const condition = mapTextToRelationaOperator(cond.op);
    switch (condition) {
      case '>=':
        if (
          cond.value > lowerBound.value ||
          (cond.value === lowerBound.value && !lowerBound.inclusive)
        ) {
          lowerBound = { value: cond.value, inclusive: true };
        }
        break;
      case '<=':
        if (
          cond.value < upperBound.value ||
          (cond.value === upperBound.value && !upperBound.inclusive)
        ) {
          upperBound = { value: cond.value, inclusive: true };
        }
        break;
    }
  }

  if (lowerBound.value < upperBound.value) {
    return true;
  } else if (lowerBound.value === upperBound.value) {
    return lowerBound.inclusive && upperBound.inclusive;
  } else {
    return false;
  }
};

export const mapRelationaOperatorToText = (value: string) => {
  switch (value) {
    case '=':
      return 'Equal to';
    case '>=':
      return 'Greater than or equal to';
    case '<=':
      return 'Less than or equal to';
    default:
      return value;
  }
};

export const mapTextToRelationaOperator = (value: string) => {
  switch (value) {
    case 'Equal to':
      return '=';
    case 'Greater than or equal to':
      return '>=';
    case 'Less than or equal to':
      return '<=';
    default:
      return value;
  }
};

function validateStringArray(arr: string[]): boolean {
  const convertedArray = arr.map((item) => mapTextToRelationaOperator(item));
  const slicedArr = convertedArray.slice(1);

  if (slicedArr.length % 2 !== 0) return false;

  const validOperators = new Set(['=', '>=', '<=']);

  for (let i = 0; i < slicedArr.length; i += 2) {
    const first = slicedArr[i];
    const second = slicedArr[i + 1];
    if (!validOperators.has(first)) return false;
    if (!/^\d+(\.\d+)?$/.test(second)) return false;
  }

  return true;
}
